import { IonButton, IonCard, IonCardContent, IonCardHeader, IonChip, IonCol, IonIcon, IonInput, IonItem, IonItemDivider, IonLoading, IonProgressBar, IonRow, IonTitle } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import Content from '../components/Content';
import PleaseLoginCard from '../components/PleaseLoginCard';
import { useProfile } from '../data/store/useProfile';
import { InviteService } from '../services/InviteService';
import { useSearchParam } from '../util/sugar';


const Invitation: React.FC = () => {
    let groupId = useSearchParam("session-id") || "public";
    let title = useSearchParam("title") || "public";

    const { authenticated } = useProfile()
    const authStatus = useProfile((x) => x.status);
    const [inviteCode, setInviteCode] = useState<string>("");
    const [verificationStatus, setStatus] = useState<"verifying" | "idle">("idle");
    const codeInput = useRef<HTMLIonInputElement>(null);
    // Wait until auth has actually resolved before deciding. Otherwise the
    // "unknown"/"authenticating" startup window reads as not-logged-in and
    // briefly flashes the login card to users who are in fact signed in.
    if (authStatus === "unknown" || authStatus === "authenticating") {
        return <Content><IonLoading mode="md" isOpen={true} message="Checking sign-in..." /></Content>
    }
    if (!authenticated) {
        return <Content><PleaseLoginCard portal={window.location.href} action={"Enter Invite Code"} /></Content>
    }
    const verify = async () => {
        setStatus("verifying");
        // Read the input itself: ionChange is debounced, so state can lag the
        // last keystrokes/paste when Submit is tapped right away. Trim the
        // whitespace that comes along when a code is copied from an email.
        const typed = await codeInput.current?.getInputElement().then((el) => el.value).catch(() => undefined);
        const code = (typed ?? inviteCode).trim();
        InviteService.verifyCode(groupId, code).then(() => {
            alert("Congrats! you're now in the session!")
            window.location.href = "/session-songs/" + groupId
        }).catch((error) => {
            alert(error instanceof Error ? error.message : "Invalid Code")
        }).finally(() => {
            setStatus("idle");
        })
    }
    if (typeof groupId === "undefined") {
        return <Content>
            <IonLoading mode="md" isOpen={verificationStatus === "verifying"} message="Verifying code" />
            <IonCard>
                <IonCardContent>
                    <IonItem color="danger">
                        <IonIcon icon={warningOutline} />
                        Invalid Invitation Link
                    </IonItem>
                </IonCardContent>
            </IonCard>
        </Content>
    }
    return (
        <Content>
            < IonRow >
                <IonCol sizeMd="8" sizeLg="6" offsetMd="2" offsetLg="3">
                    <IonCard>
                        <IonCardHeader color="tertiary" >
                            <IonTitle>Enter your Invite Code!</IonTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <IonChip>
                                {title}
                            </IonChip>
                            <IonInput ref={codeInput} placeholder="Enter your code here." aria-label="Invite code" onIonChange={(e) => {
                                setInviteCode(e.detail.value!)
                            }} >
                            </IonInput>
                            <IonItemDivider color="clear" />
                            <IonButton fill="outline" expand="full" onClick={verify}>
                                Submit
                            </IonButton>
                        </IonCardContent>
                    </IonCard>
                </IonCol></IonRow >
        </Content >
    );
};

export default Invitation;